import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { CreateOrganizationCompanyRequestDto } from '@domain/organization-company/dtos/create-organization-company.request.dto';
import { GetOrganizationCompanyRequestDto } from '@domain/organization-company/dtos/get-organization-company.request.dto';
import { ListOrganizationCompanyRequestDto } from '@domain/organization-company/dtos/list-organization-company.request.dto';
import { OrganizationCompanyResponseDto } from '@domain/organization-company/dtos/organization-company.response.dto';
import { UpdateCollectorOrganizationCompanyRequestDto } from '@domain/organization-company/dtos/update-collector-organization-company.request.dto';
import { UpdateOrganizationCompanyRequestDto } from '@domain/organization-company/dtos/update-organization-company.request.dto';
import { UpdateStateOrganizationCompanyRequestDto } from '@domain/organization-company/dtos/update-state-organization-company.request.dto';
import { UpdatePosPreferencesOrganizationCompanyRequestDto } from '@domain/organization-company/dtos/update-pos-preferences-organization-company.request.dto';

@Injectable({
  providedIn: 'root',
})
export class OrganizationCompanyService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('organization/company');
  }

  create(request: CreateOrganizationCompanyRequestDto) {
    const queryUrl = `${this.getApiUrl()}`;
    return this.http.post<ApiResponse<OrganizationCompanyResponseDto>>(
      queryUrl,
      request,
    );
  }

  update(request: UpdateOrganizationCompanyRequestDto) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/${refId}`;
    return this.http.put<ApiResponse<OrganizationCompanyResponseDto>>(
      queryUrl,
      request,
    );
  }

  updateState(request: UpdateStateOrganizationCompanyRequestDto) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/${refId}/state`;
    return this.http.patch<ApiResponse<OrganizationCompanyResponseDto>>(
      queryUrl,
      request,
    );
  }

  updatePosPreferences(
    request: UpdatePosPreferencesOrganizationCompanyRequestDto,
  ) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/${refId}/pos-preferences`;
    return this.http.patch<ApiResponse<OrganizationCompanyResponseDto>>(
      queryUrl,
      request,
    );
  }

  updateCollector(request: UpdateCollectorOrganizationCompanyRequestDto) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/${refId}/collector`;
    return this.http.patch<ApiResponse<OrganizationCompanyResponseDto>>(
      queryUrl,
      request,
    );
  }

  show(request: RefId) {
    const { refId } = request;
    const queryUrl = `${this.getApiUrl()}/show/${refId}`;
    return this.http.get<ApiResponse<OrganizationCompanyResponseDto>>(
      queryUrl,
      {},
    );
  }

  get(request: GetOrganizationCompanyRequestDto) {
    const queryUrl = `${this.getApiUrl()}/get`;
    return this.http.get<ApiResponse<OrganizationCompanyResponseDto[]>>(
      queryUrl,
      { params: { ...request } },
    );
  }

  list(request: ListOrganizationCompanyRequestDto) {
    const queryUrl = `${this.getApiUrl()}/list`;
    return this.http.get<
      ApiResponse<PageableResponse<OrganizationCompanyResponseDto>>
    >(queryUrl, { params: { ...request } });
  }
}
